import React, { useState } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { WebView } from 'react-native-webview';

const ReCaptchaWebView = ({ siteKey, onVerify }) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const handleLoad = () => {
    console.log('WebView loaded');
    setIsIframeLoading(false);
  };

  const handleMessage = (event) => {
    const token = event.nativeEvent.data;
    onVerify(token);
  };

  return (
    <View style={styles.container}>
      {isIframeLoading && (
        <View style={styles.loader}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
      <WebView
        originWhitelist={['*']}
        source={{
          uri: `https://guest-journey.s3.amazonaws.com/static/captcha.html?site_key=${encodeURIComponent(siteKey)}`,
        }}
        style={{ flex: 1}}
        onLoad={handleLoad}
        onMessage={handleMessage}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    // transform: [{ translateX: -50 }, { translateY: -50 }],
  },
});

export default ReCaptchaWebView;
